import { Extension } from "@tiptap/core"

import type { CommandProps } from "@tiptap/core"

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		alignClass: {
			setAlignClass: (className: string) => ReturnType
			unsetAlignClass: () => ReturnType
		}
	}
}

export const CustomTextAlign = Extension.create({
	name: "alignClass",

	addGlobalAttributes() {
		return [
			{
				types: ["paragraph", "heading"],
				attributes: {
					class: {
						default: null,
						parseHTML: (element) => element.getAttribute("class"),
						renderHTML: (attributes) =>
							attributes.class ? { class: attributes.class as string } : {},
					},
				},
			},
		]
	},

	addCommands() {
		return {
			setAlignClass:
				(className: string) =>
				({ commands, state }: CommandProps) => {
					const nodeType = state.selection.$from.parent.type.name
					return commands.updateAttributes(nodeType, { class: className })
				},

			unsetAlignClass:
				() =>
				({ commands, state }: CommandProps) => {
					const nodeType = state.selection.$from.parent.type.name
					return commands.updateAttributes(nodeType, { class: null })
				},
		}
	},
})
